// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { controlsContainerStyles } from "@guestsupply/Overrides/Widgets/ProductList/ProductListControlsContainer";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

controlsContainerStyles.container = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 12px;
        ${xScreen("lte", 1090)} {
            flex-direction: column;
            align-items: baseline;
            gap: 8px;
        }
        ${xScreen("lte", "md")} {
            align-items: center;
            flex-direction: row;
            gap: initial;
        }
    `,
};
controlsContainerStyles.sortAndFilterContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 22px;
    `,
};
controlsContainerStyles.sortContainer = {
    css: css`
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
controlsContainerStyles.filterContainer = {
    css: css`
        ${xScreen("lte", "md")} {
            [class^="PaginationStyle"] {
                display: none;
            }
        }
    `,
};
controlsContainerStyles.viewAndPaginationContainer = {
    css: css`
        display: flex;
        align-items: center;
        gap: 80px;
        ${xScreen("lte", 1090)} {
            width: 100%;
            justify-content: space-between;
        }
        ${xScreen("lte", "md")} {
            width: initial;
        }
    `,
};
controlsContainerStyles.viewContainer = {
    css: css`
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
